<template>
  <main class="agree">
    <!-- 제목 -->
    <h1 class="agree__title">회원가입</h1>
    <hr class="agree__divider" />

    <!-- 스텝 표시 -->
    <ol class="steps" aria-label="회원가입 진행 단계">
      <li class="step is-active">
        <div class="step__icon"><i class="fa-regular fa-id-badge" aria-hidden="true"></i></div>
        <div class="step__text"><span class="step__sub">STEP 01</span><strong>약관동의</strong></div>
      </li>
      <li class="step">
        <div class="step__icon"><i class="fa-regular fa-pen-to-square" aria-hidden="true"></i></div>
        <div class="step__text"><span class="step__sub">STEP 02</span><strong>정보입력</strong></div>
      </li>
      <li class="step">
        <div class="step__icon"><i class="fa-regular fa-circle-check" aria-hidden="true"></i></div>
        <div class="step__text"><span class="step__sub">STEP 03</span><strong>가입완료</strong></div>
      </li>
    </ol>

    <!-- 개인정보처리방침 -->
    <section class="panel">
      <h2 class="panel__title">개인정보처리방침</h2>
      <div class="panel__box" role="region" aria-label="개인정보처리방침 전문(스크롤)">
        <p class="mono">
          한국내부통제협회(이하 "협회"라 함)는 이용자들의 개인정보보호를 매우 중요시하며, 이용자가 협회의 서비스를 이용함과 동시에 온라인상에서 협회에 제공한 개인정보가 보호 받을 수 있도록 최선을 다하고
          있습니다. 이에 협회는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정 및 정보통신부가 제정한
          개인정보보호지침을 준수하고 있습니다. 협회는 개인정보 보호정책을 통하여 이용자들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지
          알려드립니다.
        </p>
        <p class="mono">
          협회는 개인정보 보호정책을 홈페이지 첫 화면에 공개함으로써 이용자들이 언제나 용이하게 보실 수 있도록 조치하고 있습니다.<br><br>
          협회의 개인정보 보호정책은 정부의 법률 및 지침 변경이나 협회의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보 보호정책의 지속적인 개선을 위하여 필요한 절차를 정하고
          있습니다.<br><br>
          협회의 개인정보 보호정책은 다음과 같은 내용을 담고 있습니다.
        </p>
        <p class="mono"><strong>가. 개인정보 수집에 대한 동의</strong><br>
          협회는 이용자들이 협회의 개인정보 보호정책 또는 이용약관의 내용에 대하여 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
        </p>
        <p class="mono"><strong>나. 개인정보의 수집목적 및 이용목적</strong><br>
          "개인정보"라 함은 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와
          용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다.<br><br>
          대부분의 협회서비스는 별도의 사용자 등록이 없이 언제든지 사용할 수 있습니다. 그러나 협회는 이용자들에게 보다 더 향상된 양질의 서비스를 제공하기 위하여 이용자 개인의 정보를 수집하고
          있습니다.<br><br>
          협회는 이용자의 사전 동의 없이는 이용자의 개인 정보를 공개하지 않으며, 수집된 정보는 아래와 같이 이용하고 있습니다.<br><br>
          첫째, 이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다. 협회는 신규 서비스개발이나 컨텐츠의 확충시에 기존 이용자들이 협회에 제공한 개인정보를 바탕으로 개발해야 할
          서비스의 우선 순위를 보다 더 효율적으로 정하고, 협회는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.<br><br>
          둘째, 협회가 제공하는 각종 정보 및 서비스 등은 대부분 무료입니다. 협회는 이러한 무료 서비스를 제공하기 위해서 광고를 게재하고 있는데, 이용자들에 대한 정확한 개인정보를 바탕으로 각 서비스나
          메뉴 등에 적절하게 광고와 내용들을 전달해 드릴 수 있으며, 이것은 궁극적으로 협회가 이용자 여러분들께 드리는 또 하나의 정보로서의 가치를 지니게 됩니다. 협회는 광고주들로부터 광고를 받아
          광고주들이 대상으로 하려는 이용자의 유형에 맞게 광고를 보여줄 뿐, 광고주들에게는 절대로 이용자들의 개인정보를 보여주거나 제공하지 않습니다.<br><br>
          셋째, 각 수집 정보 별 수집목적은 다음과 같습니다.<br>
          - 성명, 아이디, 비밀번호, 본인확인문답 : 서비스이용에 따른 민원사항의 처리를 위한 본인식별, 연령제한 서비스의 제공<br>
          - ID : 불량회원의 부정한 이용 재발 방지<br>
          - 이메일주소, 전화번호 : 고지사항 전달, 본인 의사확인, 불만처리 등 의사소통 경로의 확보, 새로운 서비스, 정보 등 최신 정보안내<br>
          - 은행계좌정보, 신용카드정보, 핸드폰번호, 전화번호 : 유료정보이용에 대한 요금결제<br>
          - 주소, 전화번호 : 청구서, 자격증 등 배송시 정확한 배송지의 확보<br>
          - 주소 : 우편물 발송<br>
          - 그 외 선택항목 : 개인맞춤서비스를 제공하기 위한 자료<br>
          - IP Address, 방문일시 : 불량회원의 부정 이용 방지와 비인가 사용 방지<br>
          - 전화번호(유선, 휴대폰) : 가입 의사 확인, 가입 및 가입횟수 제한
        </p>
        <p class="mono"><strong>다. 협회가 수집하는 개인정보 항목 및 수집방법</strong><br>
          협회는 이용자들이 회원서비스를 이용하기 위해 회원으로 가입하실 때 서비스 제공을 위한 필수적인 정보들을 온라인상에서 입력 받고 있습니다. 회원 가입시에 받는 필수적인 정보는 이름, 이메일주소
          등입니다. 또한 양질의 서비스 제공을 위하여 이용자들이 선택적으로 입력할 수 있는 사항으로서 전화번호 등을 입력 받고 있습니다.<br><br>
          또한 협회내에서의 설문조사나 이벤트 행사시 통계분석 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다. 그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상
          및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다. 그리고, 어떤 경우에라도
          입력하신 정보를 이용자들에게 사전에 밝힌 목적 이외에 다른 목적으로는 사용하지 않으며 외부로 유출하지 않습니다.<br><br>
          협회에 광고를 게재하는 광고주나 검색 등의 각종 디렉토리에 링크가 되어 있는 웹사이트들이 이용자 여러분에 대하여 개인적으로 식별할 수 있는 개인정보를 수집할 수도 있을 것입니다. 협회에 링크되어
          있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 "협회 개인정보 보호정책"이 적용되지 않음을 알려 드립니다.
        </p>
        <p class="mono"><strong>라. 협회가 수집하는 개인정보의 보유 및 이용기간</strong><br>
          이용자가 협회의 회원으로서 협회에 제공하는 서비스를 이용하는 동안 협회는 이용자들의 개인정보를 계속적으로 보유하며 서비스 제공 등을 위해 이용합니다. 다만, 아래의 "바. 이용자 자신의 개인정보
          관리(열람,정정,삭제 등)에 관한 사항" 에서 설명한 절차와 방법에 따라 회원 본인이 직접 삭제하거나 수정한 정보, 가입해지를 요청한 경우에는 해지되며 추후 적합한 방법으로 회원이 다시 될 수
          있습니다.<br><br>
          귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기하는 것을 원칙으로 합니다. 그리고 상법, 전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여
          보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 협회는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.<br><br>
          - 대금결제 및 재화등의 공급에 관한 기록 : 5년<br>
          - 회원의 불만 또는 분쟁처리에 관한 기록 : 3년<br><br>
          협회는 귀중한 회원의 개인정보를 안전하게 처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여 개인정보를 파기합니다.<br>
          - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.<br>
          - 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없도록 삭제합니다.
        </p>
        <p class="mono"><strong>마. 협회가 수집한 개인정보의 공유 및 제공</strong><br>
          협회는 이용자들의 개인정보를 "나. 개인정보의 수집목적 및 이용목적"에서 고지한 범위내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에
          공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br><br>
          - 이용자들이 사전에 공개에 동의한 경우<br>
          - 서비스 제공에 따른 요금정산을 위하여 필요한 경우<br>
          - 홈페이지에 게시한 협회 서비스 이용 약관 및 기타 회원 서비스 등의 이용약관 또는 운영원칙을 위반한 경우<br>
          - 협회서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적인 조치를 취하기 위하여 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우<br>
          - 기타 법에 의해 요구된다고 선의로 판단되는 경우 (ex. 관련법에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우 등)<br>
          - 통계작성, 학술연구나 시장조사를 위하여 특정개인을 식별할 수 없는 형태로 광고주, 협력업체나 연구 단체 등에 제공하는 경우<br>
          - 이용자의 서비스 이용에 따른 불만사항 및 문의사항(민원사항)의 처리를 위하여 파.항의 고객센터를 운영하는 전문업체에 해당 민원사항의 처리에 필요한 개인정보를 제공하는 경우<br><br>
          그리고 협회는 새로운 기술개발이나 보다 나은 서비스의 제공을 위하여 이용자들의 개인정보를 공유할 수 있습니다. 이 경우에도 정보수집 또는 정보제공 이전에 이용자들에게 개인정보를 공유할 기관이나
          단체가 누구인지, 어떤 정보가 왜 필요한지, 그리고 언제까지 어떻게 보호되고 관리되는지 알려드리고 동의를 구하는 절차를 거치게 되며, 이용자들의 동의가 없는 경우에는 추가적인 정보를 임의로
          수집하거나 공유하지 않습니다.
        </p>
        <p class="mono"><strong>바. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항</strong><br>
          이용자는 언제든지 협회 홈페이지를 이용하여 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입 해지를 요청할 수도 있습니다.<br>
          이용자들의 개인정보 조회 및 수정을 위해서는 협회 회원관리 메뉴에서 아이디와 비밀번호를 사용하여 로그인(LOG-IN)하면 되는데, 아이디(ID) 및 이름을 제외한 모든 입력사항을 수정할 수
          있습니다.<br>
          이용자들은 협회서비스의 회원 아이디(ID)에 대하여 가입해지 또는 이용해지를 할 수 있으나 이로 인하여 모든 서비스를 이용할 수 없게 되는 것은 아니며, 일부 서비스는 확인 가능합니다. 회사는
          이용자의 요청에 의해 해지 또는 삭제된 개인정보는 “라.협회가 수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
        </p>
        <p class="mono"><strong>사. 개인정보관련 의견수렴 및 불만처리에 관한 사항</strong><br>
          협회는 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. 이용자들은 홈페이지 게시판에 본인의 의견을 적을 수 있습니다.
          단, 내용이 비하발언이나 비방성 글일 경우로 판단될 경우 본인의 동의 없이 협회가 삭제 할 수 있습니다.<br><br>
          또는 정부에서 설치하여 운영중인 아래의 기관에 불만처리를 신청할 수 있습니다.<br>
          - 개인정보 침해신고센터 (https://privacy.kisa.or.kr, 전화 1336)<br>
          - 개인정보 분쟁조정위원회 (https://www.kopico.go.kr, 전화 1336)<br>
          - 정보보호마크 인증위원회 (https://www.eprivacy.or.kr, 전화 02-580-0533)<br>
          - 경찰청 (http://www.police.go.kr)
        </p>
        <p class="mono"><strong>아. 협회 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처</strong><br>
          협회는 귀하가 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 귀하께 고지한 사항들에 반하는 사고가 발생할 경우 개인정보관리책임자가 책임을
          집니다.<br><br>
          개인정보 관리 담당자<br>
          - 이 름 : 최영규<br>
          - 소속 / 직위 : 한국내부통제협회 / 사무총장<br>
          - 전화번호 : 070-4489-7447
        </p>
        <p class="mono"><strong>자. 협회 홈페이지 안내</strong><br>
          - 근무시간 : 평일 09:00~18:00 (토요일 및 일요일, 공휴일은 휴무)<br>
          - 전화번호 : 070-4489-7447<br>
          - 팩스 : 02-420-7243<br>
          - 등기우편 : 서울시 금천구 가산디지털2로 108(뉴티캐슬 9층 905호) 한국내부통제협회 홈페이지 담당자 앞<br>
          - 기타문의 : 홈페이지 안에서 메일 발송<br><br>
          그 외 개인정보에 관한 상담이 필요한 경우에는 한국정보보호진흥원(KISA)에서 운영하는 개인정보 침해신고센터 (전화 : 1336)으로 문의하실 수 있습니다.
        </p>
        <p class="mono"><strong>차. 고지의 의무</strong><br>
          현 개인정보보호정책의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다.<br>
          시행일자 : 2025년 8월 11일
        </p>
      </div>

      <label class="checkline" for="agreePrivacy">
        <input id="agreePrivacy" type="checkbox" v-model="agreePrivacy" />
        <span>개인정보처리방침에 동의합니다.</span>
      </label>
    </section>



    <!-- 서비스 이용약관 동의 -->
    <!-- 서비스 이용약관 동의 -->
    <section class="panel">
      <h2 class="panel__title">서비스 이용약관 동의</h2>
      <div class="panel__box" role="region" aria-label="서비스 이용약관 전문(스크롤)">
        <p class="mono"><strong>제 1 장 총 칙</strong></p>

        <p class="mono"><strong>제1조(목적)</strong><br>
          이 약관은 한국내부통제협회 (이하 "협회"라 함)가 인터넷서비스(이하 "서비스"라 합니다)를 제공함에 있어 협회 홈페이지의 메뉴 중 해당메뉴에 게시물을 등록하기 위하여 협회 인터넷회원으로 가입한
          회원에 대하여 협회와 인터넷회원간의 권리, 의무, 이용조건 및 절차, 기타 필요한 사항을 규정함을 목적으로 한다.
        </p>

        <p class="mono"><strong>제2조(용어의 정의)</strong><br>
          이 약관에서 사용하는 용어의 정의는 다음과 같다.
          <br>1. 인터넷회원 : 본회 홈페이지의 메뉴 중 해당메뉴에 게시물을 등록할 수 있는 권리를 부여받기 위하여 협회에 회원으로 가입한 자
          <br>2. 메뉴 : 홈페이지의 이용 및 관리의 편의를 위하여 홈페이지상에서 서로 관련성 있는 자료들을 체계적으로 분류하여 수록해 놓은 특정장소
          <br>3. 해당메뉴 이용 : 해당메뉴에 게시물을 등록하는 것
          <br>4. 아이디(ID) : 인터넷회원 식별과 인터넷회원의 서비스 이용을 위하여 인터넷회원이 선정하고 협회가 승인하는 영문자와 숫자의 조합
          <br>5. 비밀번호 : 인터넷회원이 통신상의 자신의 비밀을 보호하기 위해 선정한 영문자와 숫자의 조합
          <br>6. 전자우편(E-Mail) : 인터넷을 통한 우편주소
          <br>7. 해지 : 협회 또는 인터넷회원이 서비스 이용 이후 그 서비스이용을 종료시키는 의사표시
        </p>

        <p class="mono"><strong>제3조(약관의 유효 및 변경)</strong><br>
          ① 이 약관은 협회 홈페이지에 게시함으로써 유효하다.<br>
          ② 협회는 합리적인 사유가 있는 경우 이 약관을 변경할 수 있으며, 변경된 약관은 제1항과 같은 방법으로 게시함으로써 유효하게 된다.<br>
          ③ 인터넷회원은 변경된 약관에 동의하지 않으면 언제든지 서비스 이용을 중단하고 서비스이용을 해지할 수 있다. 이 경우 서비스 이용의 해지는 협회에 인터넷회원 가입의 해지신청을 함으로써
          해지된다.<br>
          ④ 인터넷회원이 제2항에 규정된 변경약관에 대하여 약관의 시행일 이후 별도의 통지 없이 계속적으로 서비스를 이용하는 경우 약관의 변경 사항에 동의한 것으로 간주한다.
        </p>

        <p class="mono"><strong>제4조(약관외 준용규정)</strong><br>
          이 약관에 명시되지 아니한 사항에 대해서는 전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 기타 관련 법령의 규정에 따른다.
        </p>

        <p class="mono"><strong>제 2 장 해당메뉴의 이용</strong></p>

        <p class="mono"><strong>제5조(해당메뉴의 이용절차)</strong><br>
          ① 해당메뉴를 이용하고자 하는 자는 인터넷회원 가입신청을 하여야 하며, 동 가입신청에 대하여 본회의 가입승낙이 있는 경우에 이용이 가능하다.<br>
          ② 온라인 가입 신청 양식에 기재하는 모든 인터넷회원 정보는 실제와 일치하는 데이터인 것으로 간주됩니다. 본인 실명이나 실제와 일치하는 정보를 입력하지 않은 자는 법적인 보호를 받을 수 없으며
          해당메뉴를 이용할 수 없다.
        </p>

        <p class="mono"><strong>제6조(인터넷회원가입의 불승낙 등)</strong><br>
          본회는 다음 각 호에 해당하는 경우 인터넷회원 가입신청에 대하여 승낙을 하지 않을 수 있다.<br>
          1. 인터넷회원가입 신청시 가명, 차명, 기타 신청자 본인이 아닌 다른 명의의 신청 등 가입신청 양식상의 기재 사항을 허위로 하여 신청한 경우<br>
          2. 인터넷회원가입 신청자가 이 약관 제14조 제2항에 의거하여 인터넷회원가입이 해지된 사실이 있는 경우<br>
          3. 14세 미만인 경우
        </p>

        <p class="mono"><strong>제7조(인터넷회원 가입신청 기재사항의 변경)</strong><br>
          ① 인터넷회원은 가입 후 기재사항이 변경되었을 경우에 서면 및 인터넷에 의하여 변경을 신고하여야 한다.<br>
          ② 인터넷회원이 변경된 사항에 대하여 기재사항을 신고하지 아니하거나 허위의 신고로 인하여 발생되는 문제에 대한 책임은 인터넷회원에게 있다.<br>
          ③ 인터넷회원이 아이디를 변경하는 경우 다음 각 호에 해당되면 직권에 의하여 아이디의 사용을 제한하거나 이용을 중지시킬 수 있다.<br>
          1. 아이디가 미풍양속을 해하는 경우<br>
          2. 사생활을 침해할 우려가 있는 경우<br>
          3. 기타 합리적인 사유가 있는 경우
        </p>

        <p class="mono"><strong>제8조(해당메뉴 이용 시간)</strong><br>
          해당메뉴의 이용은 연중무휴, 1일 24시간을 원칙으로 한다. 다만, 협회는 정기점검, 보수 등 업무상, 기술상의 이유로 서비스 이용의 전부 또는 일부를 제한할 수 있으며, 이 경우 협회는 사전 또는
          사후에 이를 협회의 홈페이지에 그 사실을 공지한다.
        </p>

        <p class="mono"><strong>제9조(서비스 제공의 중단)</strong><br>
          협회는 다음의 각 호에 해당하는 경우에 홈페이지 서비스 제공을 중단할 수 있다.<br>
          1. 설비의 보수 등을 위하여 부득이한 경우<br>
          2. 전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중단하는 경우<br>
          3. 국가비상사태, 천재지변 기타 불가항력적 사유가 있는 경우
        </p>

        <p class="mono"><strong>제10조(해당메뉴의 변경)</strong><br>
          협회는 필요한 경우 해당메뉴를 추가 또는 변경할 수 있으며, 추가 또는 변경 내용은 협회의 홈페이지에 공지한다.
        </p>

        <p class="mono"><strong>제 3 장 권리와 의무</strong></p>

        <p class="mono"><strong>제11조(개인 정보의 보호)</strong><br>
          ① 협회는 정보통신망이용촉진 및 정보보호 등에 관한 법률 등 관계 법령에 따라 인터넷회원 가입 신청 시 제공받은 개인 정보, 추후에 추가로 제공받는 개인 정보를 보호한다.<br>
          ② 협회의 개인정보 관리책임자를 비롯한 개인정보보호에 관한 기타 사항은 별도로 정한 "개인정보보호정책"에 기재하여 공지한다.<br>
          ③ 협회는 회원이 자발적으로 구인·구직 게시판에 등록한 개인정보(성명, 연락처, 이메일 등)에 대하여는 별도로 수집·저장·활용하지 않으며, 게시물 삭제 시 해당 개인정보 역시 즉시 삭제한다.<br>
          ④ 회원이 구인·구직 게시판에 개인정보를 공개하는 경우, 제3자가 이를 열람·수집할 수 있으며, 이에 따른 모든 결과에 대한 책임은 게시한 회원 본인에게 있다. 협회는 회원이 자발적으로 공개한
          개인정보에 대하여 별도의 관리·보호 의무를 부담하지 않는다.
        </p>

        <p class="mono"><strong>제12조(인터넷회원의 의무)</strong><br>
          ① 인터넷회원은 해당메뉴를 이용함에 있어 다음 각 호의 행위를 하여서는 안된다.<br>
          1. 타인의 서비스 아이디 및 비밀번호를 도용하는 행위<br>
          2. 타인의 지적재산권을 침해하는 행위<br>
          3. 타인의 명예를 훼손하거나 사생활을 침해하는 행위<br>
          4. 게시판 등에서 욕설, 비방 또는 음란, 폭력적인 내용의 표현을 하는 행위<br>
          5. 과실 또는 고의로 허위의 정보를 공개 또는 유포하는 행위<br>
          6. 다량의 정보를 전송하거나 동일한 또는 유사한 내용의 정보를 반복적으로 게시하여 서비스의 안정적인 운영을 방해하는 행위<br>
          7. 광고성 정보를 수신자의 의사에 반하여 게시판에 게시하여 다른 인터넷회원의 서비스 이용을 방해하는 행위<br>
          8. 정보통신설비의 오작동이나 정보 등의 파괴를 유발하는 컴퓨터 바이러스 등을 유포하는 행위<br>
          9. 협회의 서비스를 이용하여 얻은 정보를 협회의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위<br>
          10. 협회의 정상적인 경영 또는 업무를 방해하거나 서비스의 운영을 방해하는 행위<br>
          11. 불법선거운동을 하는 행위<br>
          12. 기타 미풍양속을 해하거나 관련법령 및 이 약관을 포함하여 협회가 정한 이용 조건에 위반하는 행위<br>
          ② 인터넷회원은 아이디 및 비밀번호의 관리에 상당한 주의를 기울여야 한다. 아이디와 비밀번호에 관한 모든 관리 책임은 인터넷회원에게 있으며, 인터넷회원에게 부여된 아이디 및 비밀번호의 관리 소홀,
          부정사용에 의하여 발생하는 모든 결과에 대한 책임은 인터넷회원에게 있다. 인터넷회원은 자신의 아이디 또는 비밀번호가 부정하게 사용된 경우 반드시 협회에 그 사실을 통보하여야 한다.<br>
          ③ 인터넷회원은 협회의 사전 서면 동의 없이 협회 홈페이지의 서비스를 이용하여 영리적인 목적의 영업행위를 하여서는 안된다. 이를 위반한 영업 행위의 결과에 대하여 협회는 책임을 지지 않으며, 이와
          같은 영업 행위의 결과로 협회에 손해가 발생한 경우, 인터넷회원은 협회에 대하여 손해배상의 의무를 진다.<br>
          ④ 인터넷회원은 명시적 동의가 없는 한 협회의 서비스의 이용 권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공하거나 기타 처분할 수 없다.<br>
          ⑤ 인터넷회원은 구인·구직 게시판을 이용함에 있어 다음 각 호의 행위를 하여서는 아니 된다.<br>
          1. 허위 또는 과장된 구인·구직 정보를 게시하는 행위<br>
          2. 법령에 위반되는 채용 광고(다단계, 불법 투자·알바 등)를 게시하는 행위<br>
          3. 성별·연령·장애·학력 등 차별적 내용을 포함한 채용 공고를 게시하는 행위<br>
          4. 타인의 권리를 침해하거나 미풍양속을 해치는 구인·구직 정보를 게시하는 행위
        </p>

        <p class="mono"><strong>제12조의2(협회의 책임 제한 - 구인·구직 게시판)</strong><br>
          ① 협회는 구인·구직 게시판에 게시된 정보의 정확성, 신뢰성, 합법성에 대하여 어떠한 보증도 하지 않는다.<br>
          ② 협회는 게시판을 통해 이루어지는 채용, 고용, 계약 등과 관련하여 발생하는 분쟁, 손해, 불이익 등에 대해 법적 책임을 지지 않는다.<br>
          ③ 채용 및 고용에 관한 모든 결정과 책임은 구인자와 구직자 본인에게 있다.<br>
          ④ 협회는 단순히 회원 간 구인·구직 정보를 교류할 수 있는 게시판을 제공할 뿐, 실제 고용관계의 성립, 유지 또는 종료 과정에는 일체 관여하지 않는다.
        </p>

        <p class="mono"><strong>제 4 장 해당메뉴의 이용 제한 및 해지 등</strong></p>

        <p class="mono"><strong>제13조(해당메뉴 이용 제한)</strong><br>
          협회는 인터넷회원이 제12조의 의무를 위반한 경우 인터넷회원의 서비스 이용을 일부 또는 전부 제한할 수 있다.
        </p>

        <p class="mono"><strong>제14조(인터넷회원의 해지)</strong><br>
          ① 협회는 인터넷회원이 제12조의 의무를 위반한 경우 사전 통지를 거쳐 서비스 이용을 중지시키고 인터넷 회원해지 처리를 할 수 있다. 다만, 그 내용이 중하여 협회의 정상적인 경영이나 업무 활동
          또는 서비스 운영에 지장이 있는 경우 사전통지 없이 서비스 이용을 중지시키고 해지 처리를 할 수 있다.<br>
          ② 협회는, 제1항에 의하여 해지 처리된 인터넷회원이 다시 이용 신청을 하는 경우, 그에 대한 승낙을 거절하거나 일정 기간 그 승낙을 보류할 수 있다.<br>
          ③ 유료회원이 회원탈퇴 시 기 납부한 회비는 돌려주지 않는다.
        </p>

        <p class="mono"><strong>제15조(일정기간 경과 후 삭제)</strong><br>
          ① 해당 메뉴에 등록된 게시물은 등록일로부터 2개월이 경과한 경우, 협회는 별도의 사전 통지 없이 삭제할 수 있다. 또한, 게시물이 비방·명예훼손·불법정보에 해당한다고 판단되는 경우, 협회는
          작성자의 동의 없이 즉시 삭제할 수 있다.<br>
          ② 협회는 구인·구직 게시판에 게시된 정보 중 허위, 불법, 차별적, 개인정보 침해 소지가 있는 경우, 회원의 동의 없이 즉시 삭제할 수 있다.
        </p>

        <p class="mono"><strong>부 칙 (2025. 8. 12)</strong><br>
          ① [시행일] 이 약관은 2025년 8월 12일부터 시행한다.
        </p>
      </div>

      <label class="checkline" for="agreeService">
        <input id="agreeService" type="checkbox" v-model="agreeService" />
        <span>서비스 이용약관 등에 관한 사항에 동의합니다.</span>
      </label>
    </section>


    <!-- 하단 버튼 -->
    <div class="agree__actions">
      <button type="button" class="btn btn--primary" @click="onEmailAuth">
        회원가입
      </button>
    </div>
  </main>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const agreePrivacy = ref(false)
const agreeService = ref(false)

function onEmailAuth() {
  if (!agreePrivacy.value && !agreeService.value) {
    alert('개인정보처리방침과 서비스 이용약관에 모두 동의해야 합니다.')
    return
  }
  if (!agreePrivacy.value) {
    alert('개인정보처리방침에 동의해야 합니다.')
    return
  }
  if (!agreeService.value) {
    alert('서비스 이용약관에 동의해야 합니다.')
    return
  }
  // router.push('/join-step2')
  sessionStorage.setItem('joinProgress', '1')
  router.push('/join-step2')

}
</script>

<style scoped>
/* 시스템 폰트 스택 (상업적 무료) */
.agree {
  font-family: system-ui, -apple-system, "Segoe UI", "Noto Sans KR",
    "Apple SD Gothic Neo", "Malgun Gothic", Arial, sans-serif;
  padding: 28px 16px 60px;
  background: #f8fafc;
  color: #0f172a;
}

/* 제목/구분선 */
.agree__title {
  text-align: center;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -.2px;
  margin: 8px 0 12px;
}

.agree__divider {
  max-width: 760px;
  margin: 0 auto 24px;
  border: 0;
  border-top: 1px solid #e5e7eb;
}

/* 스텝 */
.steps {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  max-width: 760px;
  margin: 0 auto 24px;
  padding: 0;
}

.step {
  display: grid;
  grid-template-columns: 44px 1fr;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  color: #334155;
}

.step__icon {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: #f1f5f9;
  color: #334155;
}

.step__text {
  display: grid;
  gap: 2px;
}

.step__sub {
  font-size: .75rem;
  color: #64748b;
}

.step strong {
  font-size: .95rem;
  font-weight: 800;
  color: #0f172a;
}

.step.is-active {
  border-color: #c7d2fe;
  box-shadow: 0 6px 18px rgba(17, 24, 39, .06);
}

.step.is-active .step__icon {
  background: #1d2088;
  color: #fff;
}

/* 패널(약관) */
.panel {
  max-width: 760px;
  margin: 0 auto 18px;
}

/* .panel__title {
  font-size: 1.05rem;
  font-weight: 800;
  margin: 18px 0 10px;
}

.panel__box {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  height: 220px;
  overflow: auto;
  padding: 14px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.02);
}

.mono {
  white-space: pre-wrap;
  line-height: 1.6;
  font-size: .95rem;
  color: #111827;
} */

.panel__box {
  max-height: 300px;
  overflow-y: auto;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
  font-family: 'Noto Sans KR', sans-serif;
  line-height: 1.6;
  white-space: pre-line;
}

.panel__title {
  font-size: 1.625rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.mono {
  font-size: 0.95rem;
  margin-bottom: 0.8rem;
}

.mono strong {
  font-weight: 700;
}


.checkline {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  color: #111827;
  font-size: .95rem;
}

.checkline input {
  width: 16px;
  height: 16px;
}

/* 행동영역 */
.agree__actions {
  max-width: 300px;
  margin: 26px auto 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.btn {
  height: 54px;
  font-size: 16px;
  font-weight: 800;
  border-radius: 12px;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.btn--primary {
  background: #1d2088;
  color: #fff;
}

.btn--primary:hover {
  background: #220e52;
}

.btn--ghost {
  background: #fff;
  color: #0f172a;
  border-color: #e5e7eb;
}

.btn--ghost:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* 모바일 */
@media (max-width: 640px) {
  .steps {
    grid-template-columns: 1fr;
  }

  .agree__divider {
    margin-bottom: 16px;
  }

  .panel__box {
    height: 200px;
  }

  .agree__actions {
    grid-template-columns: 1fr;
  }
}

/* .btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
} */
</style>
